<template>
    <div
      class="filters mr-4 w-100  d-flex align-items-center flex-column flex-lg-row"
    >
    
      <CashCallManagementTableFiltersStatus v-model="modelValue.Status" />  <span style="margin-right:20px"></span>
      <CashCallManagementTableFiltersCreateDate v-model="modelValue.created_on" /> <span style="margin-right:20px"></span>
      <CashCallManagementTableFiltersPaidDate v-model="modelValue.paid_on" /> <span style="margin-right:20px"></span>
      <CashCallManagementTableFiltersTotalIndemnity v-model="modelValue.total_indemnity" />
      <CashCallManagementTableFiltersPaidAmount v-model="modelValue.paid_amount" />
    </div>
  </template>
  
  <script>
  import { defineComponent, computed } from '@vue/composition-api'
  
  import { useCurrentUser } from '@composables'
  
  import CashCallManagementTableFiltersStatus from './CashCallManagementTableFiltersStatus.vue'
  import CashCallManagementTableFiltersCreateDate from './CashCallManagementTableFiltersCreateDate.vue'
  import CashCallManagementTableFiltersTotalIndemnity from './CashCallManagementTableFiltersTotalIndemnity.vue'
  import CashCallManagementTableFiltersPaidDate from './CashCallManagementTableFiltersPaidDate.vue'
  import CashCallManagementTableFiltersPaidAmount from './CashCallManagementTableFiltersPaidAmount.vue'

  
  export default defineComponent({
    name: 'CashCallManagementTableFilters',
    components: {
      CashCallManagementTableFiltersStatus, 
      CashCallManagementTableFiltersCreateDate,
      CashCallManagementTableFiltersTotalIndemnity,
      CashCallManagementTableFiltersPaidDate,
      CashCallManagementTableFiltersPaidAmount
    },
    props: {
      value: {
        type: Object,
        default: () => ({
          Status: 'All',
          created_on: [],
          paid_on: []
        }),
        validator: (value) =>
          Object.keys(value).every((v) =>
            [
              'Status',
              'created_on',
              'total_indemnity',
              'paid_on',
              'paid_amount'
            ].includes(v)
          )
      }
    },
    emits: ['input'],
    setup(props, { emit }) {
      const { isSuperUser } = useCurrentUser()
  
      const modelValue = computed({
        get: () => props.value,
        set: (newValue) => emit('input', newValue)
      })
  
      return {
        isSuperUser,
  
        modelValue
      }
    }
  })
  </script>
  
  <style scoped>
  .filters >>> .base-select {
    max-width: 140px;
  }
  
  .filters >>> .base-select >>> label {
    font-size: 12px;
    line-height: 1;
  }
  
  .filters >>> .base-select >>> .custom-select {
    width: 140px;
  }
  
  @media screen and (max-width: 991px) {
    .filters >>> .base-select {
      width: 100%;
      max-width: 100%;
      margin-bottom: 10px;
    }
  
    .filters >>> .base-select >>> .custom-select {
      width: 100%;
    }
  }
  </style>
  